import { render, staticRenderFns } from "./InfluencerRecommendations.vue?vue&type=template&id=8dde9fb8&scoped=true&"
import script from "./InfluencerRecommendations.vue?vue&type=script&lang=js&"
export * from "./InfluencerRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerRecommendations.vue?vue&type=style&index=0&id=8dde9fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dde9fb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
